import React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { Box } from "@material-ui/core";
import LocalHelmet from "./Helmet";

const Feedback: React.FC = () => {
    return (
        <Box alignItems="center" display="block">
        <LocalHelmet title="STATS Rent - Atsauksmes" />
        </Box>
    );
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {};
};

export default connect(null, mapDispatchToProps)(Feedback);
